export const getLanguageForSocket = language => {
  if (
    ['pl', 'es', 'ru', 'uk', 'tr', 'ar', 'it', 'nl', 'sv'].includes(language)
  ) {
    return 'xx'
  }

  return language
}

export const languageToLocale = {
  en: 'en-GB',
  de: 'de-DE',
  fr: 'fr-FR',
  nl: 'nl-NL',
  sv: 'sv-SE',
  tr: 'tr-TR',
  ru: 'ru-RU',
  uk: 'uk-UA',
  es: 'es-ES',
  pl: 'pl-PL',
  ar: 'ar-SA',
  it: 'it-IT'
}
